import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { getIncomeByFeeData } from '../../../requests/api/dashboard';
import { DEFAULT_API_ERROR_MESSAGE } from '../../../utils/errors';
import { useYear } from '../../../hooks/useYear';
import Page from '../../../components/Layout/Page';
import IndicatorsTable from '../components/table';
import { IncomeByFeeData } from '../types';
import useStyles from './styles';

const IncomeByFee: React.FC = () => {
  const classes = useStyles();
  const { selectedYear } = useYear();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [
    incomeByFeeData, setIncomeByFeeData,
  ] = useState<IncomeByFeeData>([{
    id: 'totals',
    label: '',
    values: {
      initialFee: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsOrProgramsDiscounts: { amount: 0, variation: 0 },
      totalFee: { amount: 0, variation: 0 },
      paymentMethodDiscounts: { amount: 0, variation: 0 },
      totalWithDiscounts: { amount: 0, variation: 0 },
      paidFee: { amount: 0, variation: 0 },
      feeDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lad',
    label: 'LAD',
    values: {
      initialFee: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsOrProgramsDiscounts: { amount: 0, variation: 0 },
      totalFee: { amount: 0, variation: 0 },
      paymentMethodDiscounts: { amount: 0, variation: 0 },
      totalWithDiscounts: { amount: 0, variation: 0 },
      paidFee: { amount: 0, variation: 0 },
      feeDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lod',
    label: 'LOD',
    values: {
      initialFee: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsOrProgramsDiscounts: { amount: 0, variation: 0 },
      totalFee: { amount: 0, variation: 0 },
      paymentMethodDiscounts: { amount: 0, variation: 0 },
      totalWithDiscounts: { amount: 0, variation: 0 },
      paidFee: { amount: 0, variation: 0 },
      feeDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'em',
    label: 'EM',
    values: {
      initialFee: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsOrProgramsDiscounts: { amount: 0, variation: 0 },
      totalFee: { amount: 0, variation: 0 },
      paymentMethodDiscounts: { amount: 0, variation: 0 },
      totalWithDiscounts: { amount: 0, variation: 0 },
      paidFee: { amount: 0, variation: 0 },
      feeDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'eme',
    label: 'EM - E',
    values: {
      initialFee: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsOrProgramsDiscounts: { amount: 0, variation: 0 },
      totalFee: { amount: 0, variation: 0 },
      paymentMethodDiscounts: { amount: 0, variation: 0 },
      totalWithDiscounts: { amount: 0, variation: 0 },
      paidFee: { amount: 0, variation: 0 },
      feeDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }]);

  useEffect(() => {
    const fetchIncomeByFeeData = async () => {
      try {
        const response = await getIncomeByFeeData(selectedYear);
        setIncomeByFeeData(response.incomeByFeeData);
      } catch (err) {
        const e = err as AxiosError;
        enqueueSnackbar(e.response?.data.message || DEFAULT_API_ERROR_MESSAGE, {
          variant: 'error',
        });
      }
    };

    fetchIncomeByFeeData();
  }, [selectedYear]);

  const handleGoBack = () => {
    history.push('/dashboard/financiero');
  };

  return (
    <Page title="Aranceles">
      <Box>
        <Box className={classes.backButtonContainer}>
          <IconButton
            onClick={handleGoBack}
            className={classes.backButton}
            size="small"
          >
            <ArrowBackIos className={classes.backIcon} />
          </IconButton>
          <Typography className={classes.pageTitle}>
            Aranceles
          </Typography>
        </Box>

        <Box className={classes.enrollmentsContainer}>
          <IndicatorsTable
            columns={[{
              id: 'initialFee',
              label: 'Arancel inicial',
            }, {
              id: 'specialDiscounts',
              label: 'Descuentos especiales',
            }, {
              id: 'agreementsOrProgramsDiscounts',
              label: 'Convenios / Cantidad',
            }, {
              id: 'totalFee',
              label: 'A pago arancel',
              highlightBackground: true,
            }, {
              id: 'paymentMethodDiscounts',
              label: 'Descuento F/pago',
            }, {
              id: 'totalWithDiscounts',
              label: 'Total a pago',
            }, {
              id: 'paidFee',
              label: 'Arancel pagado',
            }, {
              id: 'feeDebt',
              label: 'Deuda arancel',
            }, {
              id: 'debtPercentage',
              label: '% Deuda',
            }]}
            rows={incomeByFeeData}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default IncomeByFee;
